var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 252,
    viewBox: "0 0 1920 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 78.0891C1900.55 80.1123 1881.45 84.9402 1863.32 92.4526C1852.4 96.9756 1841.92 102.433 1831.99 108.75C1772.37 45.4893 1687.79 6 1594 6C1481.88 6 1382.93 62.4307 1324.02 148.44C1317.28 146.844 1310.24 146 1303 146C1263.76 146 1230.32 170.84 1217.54 205.654C1191.35 186.385 1159.01 175 1124 175C1087.37 175 1053.65 187.467 1026.85 208.39C988.792 153.185 925.122 117 853 117C774.748 117 706.445 159.597 670.015 222.869C663.531 221.642 656.841 221 650 221C620.626 221 594.016 232.836 574.681 252H1920V78.0891Z",
    fill: "#FEDC74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.542 252H0V58.6714C38.6587 22.2915 90.7261 0 148 0C233.208 0 306.892 49.3379 342.043 121.003C419.837 121.503 484.373 177.871 497.542 252Z",
    fill: "#FEDC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomImage);
export default __webpack_public_path__ + "static/media/bottomImage.08f4cabfe203391505c2697b86e52391.svg";
export { ForwardRef as ReactComponent };